/**
 * Temporal Intelligence + Smoothing — Prompt.md §15, §16.
 *
 * "Đây là phần quan trọng nhất của StudyStraight. Không cảnh báo dựa trên single frame."
 */

export interface TemporalConfig {
  /**
   * Alpha của EMA (§16). Càng nhỏ càng mượt nhưng càng chậm phản ứng.
   * 0.25 ≈ hằng số thời gian ~3 frame ở 12 FPS (~250ms) — đủ để dập jitter mà vẫn kịp
   * nhận ra tư thế đổi thật.
   */
  smoothingAlpha: number;

  /** Cửa sổ median lọc spike đơn lẻ trước khi vào EMA. 3 là đủ; 5 làm trễ thấy rõ. */
  medianWindow: number;

  /** §15: lỗi kéo dài < mốc này → ignore ("không coi việc cúi ngắn để viết là lỗi" §13). */
  ignoreBelowMs: number;
  /** §15: 2–5 giây → observe (state POTENTIAL_ISSUE / NEEDS_ADJUSTMENT). */
  observeUntilMs: number;
  /** §15: > 5 giây → phát event cho AlertEngine. */
  alertAfterMs: number;

  /**
   * Phải giữ tư thế tốt liên tục bao lâu mới quay về GOOD (hysteresis).
   * Không có nó, trẻ ở ngay mép ngưỡng sẽ tạo chuỗi BAD→GOOD→BAD và mỗi lần re-entry lại
   * khởi động một chu kỳ alert mới — cooldown chỉ che triệu chứng chứ không chữa nguyên nhân.
   */
  recoveryMs: number;

  /** Không có frame hợp lệ trong bao lâu thì coi là mất tracking (≠ lỗi tư thế). */
  trackingLostAfterMs: number;
}

export const defaultTemporalConfig: TemporalConfig = {
  smoothingAlpha: 0.25,
  medianWindow: 3,
  ignoreBelowMs: 2000,
  observeUntilMs: 5000,
  alertAfterMs: 5000,
  recoveryMs: 1500,
  trackingLostAfterMs: 2000,
};
